// Deterministic GrapesJS page id for a CRM deal's listing page.
// Must stay 24 lowercase hex chars — that's the ObjectId-shape check in
// TemplateBuilder.jsx's customStoragePlugin.store() migration logic, which
// otherwise treats the id as "invalid" and replaces it with a random one on
// every autosave, breaking dedup across repeat visits for the same deal.

function fnv1a(str, seed) {
  let hash = seed >>> 0
  for (let i = 0; i < str.length; i++) {
    hash ^= str.charCodeAt(i)
    hash = Math.imul(hash, 0x01000193) >>> 0
  }
  return hash
}

export function dealPageId(dealId) {
  const id = String(dealId)
  const h1 = fnv1a(id, 0x811c9dc5).toString(16).padStart(8, '0')
  const h2 = fnv1a(`${id}:2`, 0x01000193).toString(16).padStart(8, '0')
  const h3 = fnv1a(`${id}:3`, 0x9e3779b9).toString(16).padStart(8, '0')
  return (h1 + h2 + h3).slice(0, 24)
}
